import React from 'react';
import PropTypes from 'prop-types';

import RadioGroup from './index';

const MultiPicklistRadioGroup = ({
  onChange,
  value,
  ...rest
}) => {
  return (
    <RadioGroup
      onChange={(v) => {
        return onChange([v]);
      }}
      value={value[0]}
      {...rest}
    />
  );
};

MultiPicklistRadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default MultiPicklistRadioGroup;
